import { AnimatePresence, motion, useReducedMotion } from 'motion/react';
import { Bolt } from '../design-system';
import { useSkipAnimation } from './playerPreference';

const SIZE = 20;
const GAP = 8;
const FOLD = { duration: 0.28, ease: [0.4, 0, 0.2, 1] } as const;

/**
 * The bolt in front of the buy CTA's label while the player's skip is on: it
 * unfolds from nothing (its width and the gap after it, the glyph growing
 * into place) and folds away when the skip goes, so the label glides rather
 * than jumps. Renders nothing while the skip is off.
 */
export function SkipBolt() {
  const skipping = useSkipAnimation();
  const reduceMotion = useReducedMotion();
  return (
    <AnimatePresence initial={false}>
      {skipping && (
        <motion.span
          key="bolt"
          className="inline-flex items-center overflow-hidden"
          initial={reduceMotion ? false : { width: 0, opacity: 0 }}
          animate={{ width: SIZE + GAP, opacity: 1 }}
          exit={reduceMotion ? { opacity: 0 } : { width: 0, opacity: 0 }}
          transition={reduceMotion ? { duration: 0 } : FOLD}
        >
          <motion.span
            className="inline-flex"
            initial={reduceMotion ? false : { scale: 0.5 }}
            animate={{ scale: 1 }}
            exit={reduceMotion ? {} : { scale: 0.5 }}
            transition={reduceMotion ? { duration: 0 } : FOLD}
          >
            <Bolt size={SIZE} fill="currentColor" />
          </motion.span>
        </motion.span>
      )}
    </AnimatePresence>
  );
}
